export const DEFAULT_ITEMS: string[] = [
  'Buy to Detail',
  'Cart to Detail',
  'Avg. Time on Page',
  'Product Revenue',
  'Unique Purchases',
  'Pageviews',
  'Unique Pageviews'
];
  							